import {
  y2018,
  y2019,
  y2020,
  y2021,
  y2022,
  y2023,
  y2024,
  y2025,
  y2026,
} from "@hyunbinseo/holidays-kr";
import * as req from "@script/req";

/**
 * 해당 연도/월의 대한민국 공휴일(대체공휴일 포함) 목록을 가져옵니다.
 * 2018-2026년: 프론트엔드 라이브러리 사용
 * 그 외 연도: 백엔드 API 사용
 *
 * @param year 연도 (예: 2025)
 * @param month 월 (1 ~ 12)
 * @returns ["YYYY-MM-DD", "YYYY-MM-DD", ...] 형태의 문자열 배열
 */
export const getHolidayDates = async (
  year: number,
  month: number
): Promise<string[]> => {
  // 연도별 공휴일 데이터 매핑
  const yearDataMap: Record<number, any> = {
    2018: y2018,
    2019: y2019,
    2020: y2020,
    2021: y2021,
    2022: y2022,
    2023: y2023,
    2024: y2024,
    2025: y2025,
    2026: y2026,
  };

  const yearData = yearDataMap[year];

  // 라이브러리에 데이터가 없으면 백엔드 API 사용
  if (!yearData) {
    try {
      const holidays = await req.holidays(year, month);
      return holidays;
    } catch (err) {
      console.error(`${year}년 ${month}월 공휴일 API 조회 실패:`, err);
      return [];
    }
  }

  // 라이브러리에서 해당 월의 공휴일 필터링
  const monthString = String(month).padStart(2, "0");
  const prefix = `${year}-${monthString}`;

  const filteredHolidays = Object.keys(yearData).filter((date) =>
    date.startsWith(prefix)
  );

  return filteredHolidays;
};
